import React from "react";
import { useNavigate } from "react-router-dom";
import "./Story.css";
import "./contentpage.css";

function ForewordIslamicJurisprudence() {
  const navigate = useNavigate();

  const handleBegin = () => {
    navigate("/islamic-trade-page-1"); //
  };
  return (
    <div className="story-page">
      <div className="story-container">
        بسم الله الرحمن الرحيم
        <h1 className="story-title">Curators Foreword</h1>
        <h3>Islamic Jurisprudence on Finance</h3>
        <p className="story-text">
          <p className="story-text">
            This section introduces the fundamental principles of Islamic
            jurisprudence as they relate to financial transactions. It covers
            the core rulings of buying and selling, partnerships, loans, and the
            prohibitions of ribā and gharar. Before attempting to understand
            Bitcoin, it is essential to first learn the foundations of financial
            dealings in Islam. When our foundations are sound, the study of
            subsidiary sciences becomes easier, as we gain the ability to assess
            worldly skills and systems through the parameters of our deen.
            Islamic sciences, after all, are the mother of all worldly sciences
            and represent the most elite and highest form of knowledge.
            <br />
            <br />
            I do not claim to be an expert in Islamic sciences. Rather, I am a
            humble student of knowledge who has made an effort to curate and
            share the benefits I have personally derived from my own study of
            this discipline. Whatever is correct is from Allah, and any
            shortcomings are from myself.
            <br />
            <br />
            This section is primarily based on the book Sharh al-Mumti' 'ala Zad
            al-Mustaqni by Shaykh Muhammad Ibn Saleh Al-Uthaymin (رحمه الله),
            which is an explanation of Zad al-Mustaqni by Imam Ali al-Hajawi
            (رحمه الله), a book that has been widely taught in Islamic seminaries since almost 500 years.
            <br />
            <br />
            The learner receives a badge at both the beginning and the
            completion of this section. The term “graduate” is purely figurative
            and is used only to congratulate the learner and gamify the learning
            process.
            <br />
            <br />
            Each lesson includes a dashboard with a timer, a summary paragraph,
            and four MCQs to test understanding.
            <br />
            <br />
            The ideal pace is one lesson per day, though learners may adjust
            according to their capacity.
          </p>
        </p>
        {/* BUTTON */}
        <button className="popup-close-btn" onClick={handleBegin}>
          Let us begin!
        </button>
      </div>
    </div>
  );
}

export default ForewordIslamicJurisprudence;
